<template>
  <div class="field-option-customer-info-wrapper">
    <div class="top-hair" />
    <div class="field-option-wrapper">
      <div class="text-input-wrapper">
        <!-- <field-option-customer-info-input
          v-if="sty === 2"
          label="优惠卡号"
          placeholder="请输入优惠卡号"
          @change="$event => handleFieldChange('discountCardNo', $event)"
        /> -->

        <field-option-customer-info-input
          v-if="name == 1"
          label="姓名"
          placeholder="请输入姓名"
          @change="$event => handleFieldChange('name', $event)"
        />

        <field-option-customer-info-input
          v-if="idcard == 1"
          :label="label"
          placeholder="请输入证件号"
          :maxlength="18"
          :nameIcon="changeNoType ? 'arrow-up' : 'arrow-down'"
          @change="$event => handleFieldChange('identityNo', $event)"
        />

        <display-certificates
          v-if="changeNoType"
          @change="$event => handleFieldChange('noType', $event)"
        />
      </div>
    </div>
    <div class="bottom-hair" />
  </div>
</template>
<script>
import FieldOptionCustomerInfoInput from '@/components/FieldOptionCustomerInfoInput.vue';
import DisplayCertificates from '@/components/DisplayCertificates';

export default {
  components: {
    FieldOptionCustomerInfoInput,
    DisplayCertificates,
  },
  props: {
    sty: [Number],
    name: [Number],
    idcard: [Number],
  },
  data() {
    return {
      value: { noType: '1' },
      changeNoType: false,
      label: '身份证',
    };
  },
  methods: {
    handleFieldChange(key, val) {
      if (val === 'noType') {
        this.changeNoType = !this.changeNoType;
      } else if (typeof val === 'object') {
        this.changeNoType = !this.changeNoType;
        this.label = val.type;
        this.value = { ...this.value, noType: val.noType };
        this.$emit('change', this.value);
      } else {
        this.value[key] = val;
        this.$emit('change', this.value);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.field-option-customer-info-wrapper {
  .top-hair {
    border-top: 1px dashed #eee;
    margin: 0 16px;
  }
  &:last-child {
    .bottom-hair {
      border-top: 1px dashed #eee;
      margin: 0 16px;
    }
  }
  .field-option-wrapper {
    display: flex;
    .text-input-wrapper {
      flex: 1;
      position: relative;
    }
    .face-image-wrapper {
      display: flex;
      z-index: 1;
      margin-right: 8px;
      align-items: center;
    }
  }
}
</style>
